import { Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { RhNetService } from 'src/app/services/rhNet.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { HelperService } from 'src/app/utils/helper.service';
import { DialogConfirmComponent } from '../../dialogs/dialog-confirm/dialog-confirm.component';
import { Column } from '../../table/table.component';
import { AddServidorComponent } from '../add-servidor/add-servidor.component';
import { ServidorService } from '../servidor.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { EditServidorComponent } from '../edit-servidor/edit-servidor.component';
@Component({
  selector: 'app-busca-servidor',
  templateUrl: './busca-servidor.component.html',
  styleUrls: ['./busca-servidor.component.css'],
})
export class BuscaServidorComponent implements OnInit, OnChanges {

  @Output() servidor = new EventEmitter<any>();
  @Input() disabled: boolean;
  @Input() isLoading: boolean;
  @Input() cadastroNovo: boolean = true;
  @Input() icon: string;
  @Input() label: string;
  @Input() appearance: string;
  @Input() inputClasses: string;
  @Input() buttonTooltip: string;
  @Input() toolTip: string;
  @Input() tooltipPosition: string;
  @ViewChild('input') inputElement: ElementRef;

  cpfForm: UntypedFormControl;
  isProgress: boolean;

  constructor(
    private rhNetService: RhNetService,
    private servidorService: ServidorService,
    private dialog: MatDialog,
    private helper: HelperService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.cpfForm = new UntypedFormControl({ value: null, disabled: this.disabled }, [Validators.required, this.helper.cpfValidator]);
  }

  public getForm() {
    return this.cpfForm;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.cpfForm) {
      if (changes.disabled.currentValue) {
        this.cpfForm.disable();
      } else {
        this.cpfForm.enable();
      }
    }
  }

  private getErroSalvarServidor(error: any, fallback: string): string {
    const payload = error?.error;

    if (typeof payload?.message === 'string') {
      return payload.message;
    }

    if (payload?.message && typeof payload.message === 'object') {
      const mensagens = Object.values(payload.message)
        .flat()
        .filter((msg): msg is string => typeof msg === 'string');

      if (mensagens.length > 0) {
        return mensagens.join(' ');
      }
    }

    return fallback;
  }

  private tratarErroSalvarServidor(error: any, fallback: string): void {
    this.isProgress = false;
    this.restaurarValidacaoCpf();
    this.cpfForm.enable();
    this.cpfForm.reset();
    this.inputElement?.nativeElement?.focus();
    console.error(error);
    this.snackBar.showSnackBarError(this.getErroSalvarServidor(error, fallback));
  }

  private restaurarValidacaoCpf(): void {
    this.cpfForm.setValidators([Validators.required, this.helper.cpfValidator]);
    this.cpfForm.updateValueAndValidity({ emitEvent: false });
  }

  private emitirServidorSelecionado(servidor: any): void {
    this.isProgress = false;
    this.cpfForm.clearValidators();
    this.cpfForm.setErrors(null);
    this.cpfForm.reset();
    this.cpfForm.updateValueAndValidity({ emitEvent: false });
    this.cpfForm.enable();
    if (this.inputElement?.nativeElement) {
      this.inputElement.nativeElement.blur();
    }
    this.servidor.emit(servidor);
  }

  getServidor(cpf) {
    this.restaurarValidacaoCpf();
    if (this.cpfForm.invalid) {
      this.cpfForm.markAsTouched();
      return;
    }
    this.isProgress = true;
    this.cpfForm.disable();
    this.rhNetService.getServidorByCPF({ cpf: cpf })
      .subscribe((res: any) => {
        this.isProgress = false;
        this.cpfForm.enable();
        this.inputElement.nativeElement.focus();

        if (!res) {
          this.openNewServidorDialog(null, cpf);
          return;
        }

        if (!res.nome || !res.cpf) {
          this.openNewServidorDialog(null, cpf);
          this.cpfForm.reset();
          return;
        }

        // Verifica se são dados brutos (tem vinculos[].vinculosVaga[]) ou processados (tem vinculos[].regimeJuridico)
        const isDadosBrutos = res.vinculos && res.vinculos.length > 0 &&
                              res.vinculos[0].vinculosVaga && Array.isArray(res.vinculos[0].vinculosVaga);

        // Processa dados brutos do RHNet e filtra apenas vínculos ativos
        const servidorProcessado = isDadosBrutos ? this.processarDadosBrutosRHNet(res) : res;

        if (!servidorProcessado.vinculos || servidorProcessado.vinculos.length === 0) {
          if (this.cadastroNovo)
            this.openUpdateServidorDialog(servidorProcessado, cpf);
          else
            this.snackBar.showSnackBarError('Servidor sem vínculo ativo');
          return;
        }

        if (servidorProcessado.vinculos.length > 1) {
          const cpf = servidorProcessado.cpf
          const dialogRef = this.dialog.open(selectVinculoComponent, {
            width: '100%',
            disableClose: true,
            data: {
              servidor: {
                nome: servidorProcessado.nome,
                cpf: this.formatCpf(servidorProcessado.cpf)
              },
              vinculos: servidorProcessado.vinculos
            }
          });
          dialogRef.afterClosed()
            .subscribe(vinculo => {
              if (vinculo) {
                let servidor = servidorProcessado;
                servidor.vinculo = vinculo;
                // Salva o servidor no banco e aguarda para obter os IDs
                this.salvarServidorNoBancoEAguardar(servidorProcessado.cpf, servidor);
              }
            });
        } else if (servidorProcessado.vinculos.length === 1) {
          let servidor = servidorProcessado;
          servidor.vinculo = servidorProcessado.vinculos[0];
          // Salva o servidor no banco e aguarda para obter os IDs
          this.salvarServidorNoBancoEAguardar(servidorProcessado.cpf, servidor);
        }
      }, error => {
        switch (error.error.code) {
          case 45:
            this.openNewServidorDialog(null, cpf);
            break;
          default:
            console.error(error);
            this.isProgress = false;
            this.cpfForm.enable();
            this.cpfForm.reset();
            this.inputElement.nativeElement.focus();
            this.snackBar.showSnackBarError('Erro ao conectar ao RHNet');
            break;
        }
      })
  }
  openUpdateServidorDialog(servidor, cpfOrigem?: string) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '540px',
      data: {
        title: 'Nenhum vínculo ativo encontrado',
        msg: 'Este CPF não possui vínculos ativos no RHNet. Deseja Continuar o cadastro?',
        confirmLabel: 'Sim, cadastrar',
        dismissLabel: 'Não'
      }
    });
    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          if (result) {
            if (!servidor.id) {
              const cpfParaSalvar = servidor.cpf || cpfOrigem;
              this.rhNetService.salvarServidorNoBanco(cpfParaSalvar).subscribe({
                next: (res: any) => {
                  this.abrirEdicaoTerceirizado(res?.id, servidor);
                },
                error: () => {
                  this.abrirCadastroManualTerceirizado(cpfParaSalvar, servidor);
                }
              });
            } else {
              this.abrirEdicaoTerceirizado(servidor.id, servidor);
            }
          } else {
            this.isProgress = false;
            this.cpfForm.enable();
            this.cpfForm.reset();
            this.inputElement.nativeElement.focus();
          }
        }
      });
  }

  private abrirEdicaoTerceirizado(servidorId: number, dadosRHNet?: any) {
    const innerDialogRef = this.dialog.open(EditServidorComponent, {
      data: {
        id: servidorId,
        dadosRHNet: dadosRHNet
      }
    });
    innerDialogRef.afterClosed()
      .pipe(take(1))
      .subscribe(servidorEditado => {
        if (!servidorEditado) {
          this.isProgress = false;
          this.cpfForm.enable();
          this.cpfForm.reset();
          this.inputElement.nativeElement.focus();
          return;
        }
        this.servidorService.updateServidor(servidorEditado.id, servidorEditado)
          .subscribe(
            (res: any) => {
              this.isProgress = false;
              this.cpfForm.enable();
              this.cpfForm.reset();
              this.inputElement.nativeElement.focus();
              let servidorResult = res;

              // Pega o vínculo ativo ou o último vínculo da lista
              const vinculoAtivo = res.vinculos.find((v: any) => v.ativo === true);
              servidorResult.vinculo = vinculoAtivo || res.vinculos[res.vinculos.length - 1];

              this.emitirServidorSelecionado(servidorResult);
            },
            error => {
              this.tratarErroSalvarServidor(error, 'Erro ao salvar servidor');
            }
          );
      });
  }

  private abrirCadastroManualTerceirizado(cpf: string, dadosRHNet?: any) {
    const innerDialogRef = this.dialog.open(AddServidorComponent, {
      data: {
        cpf: cpf,
        dadosRHNet: dadosRHNet
      }
    });
    innerDialogRef.afterClosed()
      .subscribe(novoServidor => {
        if (!novoServidor) {
          this.isProgress = false;
          this.cpfForm.enable();
          this.cpfForm.reset();
          this.inputElement.nativeElement.focus();
          return;
        }
        this.servidorService.novoServidor(novoServidor)
          .subscribe(
            (res: any) => {
              let servidorResult = res;
              servidorResult.vinculo = res.vinculos[0];
              this.emitirServidorSelecionado(servidorResult);
            },
            error => {
              this.tratarErroSalvarServidor(error, 'Erro ao salvar novo servidor');
            }
          );
      });
  }

  openNewServidorDialog(dadosRHNet?: any, cpf?: string) {
    const cpfFinal = cpf || this.cpfForm.value;
    const cpfSemFormatacao = cpfFinal ? cpfFinal.toString().replace(/\D/g, '') : '';

    this.servidorService.buscaServidorPorCPF(cpfSemFormatacao).subscribe({
      next: (servidorLocal: any) => {
          const dialogRef = this.dialog.open(DialogConfirmComponent, {
          width: '540px',
          data: {
            title: 'Servidor encontrado na base de dados',
            msg: 'Servidor não foi encontrado no RHNet, mas foi encontrado na base de dados. Deseja utilizar os dados do servidor?',
            confirmLabel: 'Sim, utilizar',
            dismissLabel: 'Cancelar'
          }
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.isProgress = false;
            this.cpfForm.enable();
            this.cpfForm.reset();
            this.inputElement.nativeElement.focus();

            let servidorFormatado = servidorLocal;
            if (servidorLocal.vinculos && servidorLocal.vinculos.length > 0) {
              if (servidorLocal.vinculos.length > 1) {
                const dialogVinculo = this.dialog.open(selectVinculoComponent, {
                  width: '100%',
                  disableClose: true,
                  data: {
                    servidor: {
                      nome: servidorLocal.nome,
                      cpf: this.formatCpf(servidorLocal.cpf)
                    },
                    vinculos: servidorLocal.vinculos
                  }
                });
                dialogVinculo.afterClosed().subscribe(vinculo => {
                  if (vinculo) {
                    servidorFormatado.vinculo = vinculo;
                    this.emitirServidorSelecionado(servidorFormatado);
                  }
                });
              } else {
                servidorFormatado.vinculo = servidorLocal.vinculos[0];
                this.emitirServidorSelecionado(servidorFormatado);
              }
            } else {
              this.snackBar.showSnackBarError(
                'Servidor encontrado sem vínculo cadastrado. Cadastre um novo vínculo ou atualize o servidor.'
              );
            }
          } else {
            this.isProgress = false;
            this.cpfForm.enable();
            this.cpfForm.reset();
            this.inputElement.nativeElement.focus();
          }
        });
      },
      error: (err) => {
        const dialogRef = this.dialog.open(DialogConfirmComponent, {
          width: '540px',
          data: {
            title: 'CPF sem dados no RHNet',
            msg: 'Este CPF não possui dados cadastrados no RHNet. Normalmente, CPFs sem cadastro são de terceirizados. Deseja cadastrá-lo manualmente como terceirizado?',
            confirmLabel: 'Sim, cadastrar',
            dismissLabel: 'Não'
          }
        });
        dialogRef.afterClosed()
          .subscribe((result => {
            if (result) {
              const innerDialogRef = this.dialog.open(AddServidorComponent, {
                data: {
                  cpf: cpfSemFormatacao,
                  dadosRHNet: dadosRHNet
                }
              });
              innerDialogRef.afterClosed()
                .subscribe(servidor => {
                  if (!servidor) {
                    this.isProgress = false;
                    this.cpfForm.enable();
                    this.cpfForm.reset();
                    this.inputElement.nativeElement.focus()
                    return;
                  }
                  this.servidorService.novoServidor(servidor)
                    .subscribe(
                      (res: any) => {
                        let servidor = res;
                        servidor.vinculo = res.vinculos[0];
                        this.emitirServidorSelecionado(servidor);
                      },
                      error => {
                        this.tratarErroSalvarServidor(error, 'Erro ao salvar novo servidor');
                      }
                    );
                });
            } else {
              this.isProgress = false;
              this.cpfForm.enable();
              this.cpfForm.reset();
              this.inputElement.nativeElement.focus()
            }
          }));
      }
    });
  }
  keyPressSubmit(event) {
    event.key === "Enter" ? this.getServidor(this.cpfForm.value) : null;
  }
  onBlur() {
    this.cpfForm.setErrors(null);
    this.cpfForm.updateValueAndValidity();
  }
  isFocused(a) { return document.activeElement === a }
  formatCpf(cpf: string): string {
    return cpf.match(/.{1,3}/g).join(".").replace(/\.(?=[^.]*$)/, "-");
  }

  /**
   * Processa dados brutos do RHNet e filtra apenas vínculos ativos (statusVinculoVaga == "S")
   * Transforma para o formato esperado pelo componente
   */
  private processarDadosBrutosRHNet(dadosBrutos: any): any {
    const vinculosAtivos = [];

    // Itera sobre todos os vínculos
    for (let i = 0; i < dadosBrutos.vinculos.length; i++) {
      const vinculo = dadosBrutos.vinculos[i];

      // Itera sobre os vínculos de vaga dentro de cada vínculo
      for (let j = 0; j < vinculo.vinculosVaga.length; j++) {
        const vinculoVaga = vinculo.vinculosVaga[j];

        // Filtra apenas vínculos ativos (statusVinculoVaga == "S")
        if (vinculoVaga.statusVinculoVaga == "S") {
          // Transforma para o formato esperado pelo componente
          vinculosAtivos.push({
            id: vinculoVaga.codigoVinculoVaga,
            codigo: vinculoVaga.codigoVinculoVaga,
            ativo: true,
            chefia: vinculo.exerceFuncaoChefia == 'S',
            regimeJuridico: {
              id: vinculo.codigoRegimeJuridico,
              codigo: vinculo.codigoRegimeJuridico,
              descricao: vinculo.descricaoRegimeJuridico
            },
            cargo: {
              id: vinculoVaga.sequenciaCargo,
              codigo: vinculoVaga.sequenciaCargo,
              descricao: vinculoVaga.descricaoCargo,
              grupo: {
                id: vinculoVaga.codgGrupoCargo,
                codigo: vinculoVaga.codgGrupoCargo,
                descricao: vinculoVaga.descGrupoCargo,
                escolaridade: null,
                tipo: {
                  codigo: vinculoVaga.tipoGrupoCargo,
                  descricao: null
                }
              }
            },
            funcaoAtividade: vinculoVaga.codigoAtividadeFuncao != 0 ? {
              id: vinculoVaga.codigoAtividadeFuncao,
              codigo: vinculoVaga.codigoAtividadeFuncao,
              descricao: vinculoVaga.descricaoAtividadeFuncao
            } : null,
            orgao: {
              origem: {
                id: vinculoVaga.orgaoOrigemCodg,
                codigo: vinculoVaga.orgaoOrigemCodg,
                nome: vinculoVaga.orgaoOrigemDesc,
                sigla: null,
                central: false
              },
              lotacao: {
                id: vinculo.codigoOrgao,
                codigo: vinculo.codigoOrgao,
                nome: vinculo.nomeOrgao,
                sigla: null,
                central: false
              }
            },
            unidadeAdmLotacao: {
              id: vinculo.identificadorUnidadeAdministrativa,
              codigo: vinculo.identificadorUnidadeAdministrativa,
              descricao: vinculo.descricaoUnidadeAdministrativa
            },
            cpf_superior_imediato: vinculo.cpfSuperiorImediato
          });
        }
      }
    }

    // Retorna no formato esperado pelo componente
    return {
      id: null, // Não temos ID quando vem direto do RHNet
      nome: dadosBrutos.nome,
      cpf: dadosBrutos.cpf ? String(dadosBrutos.cpf).padStart(11, '0') : dadosBrutos.cpf,
      dataNascimento: dadosBrutos.dataNascimento,
      genero: dadosBrutos.siglaSexo === 'M' ? 'MASCULINO' : 'FEMININO',
      email: dadosBrutos.email || null,
      telefone: this.getTelefone(dadosBrutos.telefones),
      estadoCivil: dadosBrutos.estadoCivil === 'C' ? 'CASADO' : 'SOLTEIRO',
      vinculos: vinculosAtivos
    };
  }

  /**
   * Salva o servidor no banco de dados após seleção de vínculo
   * Isso garante que os vínculos sejam salvos corretamente com status ativo
   */
  private salvarServidorNoBanco(cpf: string) {
    this.rhNetService.salvarServidorNoBanco(cpf).subscribe({
      next: (res) => {
        // Servidor salvo com sucesso no banco
        console.log('Servidor salvo no banco:', res);
      },
      error: (err) => {
        // Log do erro mas não bloqueia o fluxo
        console.warn('Erro ao salvar servidor no banco (não crítico):', err);
      }
    });
  }

  /**
   * Salva o servidor no banco e aguarda para obter os IDs antes de emitir
   * Isso garante que servidorId e vinculoId estejam disponíveis
   */
  private salvarServidorNoBancoEAguardar(cpf: string, servidor: any) {
    // Guarda o código do vínculo selecionado para encontrar depois
    const codigoVinculoSelecionado = servidor.vinculo?.codigo;

    this.rhNetService.salvarServidorNoBanco(cpf).subscribe({
      next: (res: any) => {
        // Atualiza o servidor com os IDs do banco
        if (res && res.id) {
          servidor.id = res.id;
          // Cria estrutura servidor.servidor para compatibilidade com setAgente
          servidor.servidor = {
            id: res.id,
            nome: res.nome,
            cpf: res.cpf
          };
          servidor.servidorId = res.id;
        }

        // Atualiza o vínculo com o ID correto do banco
        if (res && res.vinculos && res.vinculos.length > 0) {
          let vinculoSalvo = null;

          // Tenta encontrar o vínculo pelo código (do RHNet)
          if (codigoVinculoSelecionado) {
            vinculoSalvo = res.vinculos.find((v: any) =>
              v.codigo && v.codigo.toString() === codigoVinculoSelecionado.toString()
            );
          }

          // Se não encontrou pelo código, tenta pelo primeiro vínculo ativo
          if (!vinculoSalvo && res.vinculos.length > 0) {
            // Procura por vínculo ativo
            vinculoSalvo = res.vinculos.find((v: any) => v.ativo === true) || res.vinculos[0];
          }

          if (vinculoSalvo) {
            // Atualiza o vínculo com os dados do banco (incluindo ID)
            servidor.vinculo = vinculoSalvo;
            servidor.vinculoId = vinculoSalvo.id;
          }
        }

        // Emite o servidor com os IDs corretos
        this.emitirServidorSelecionado(servidor);
      },
      error: (err) => {
        const cpfLimpo = cpf.replace(/\D/g, '');
        this.servidorService.buscaServidorPorCPF(cpfLimpo).subscribe({
          next: (servidorDB: any) => {
            if (servidorDB && servidorDB.id) {
              servidor.id = servidorDB.id;
              servidor.servidor = { id: servidorDB.id, nome: servidorDB.nome, cpf: servidorDB.cpf };
              servidor.servidorId = servidorDB.id;

              if (servidorDB.vinculos && servidorDB.vinculos.length > 0) {
                const codigoVinculo = servidor.vinculo?.codigo;
                let vinculoSalvo = codigoVinculo
                  ? servidorDB.vinculos.find((v: any) => v.codigo && v.codigo.toString() === codigoVinculo.toString())
                  : null;

                if (!vinculoSalvo) {
                  vinculoSalvo = servidorDB.vinculos.find((v: any) => v.ativo === true) || servidorDB.vinculos[0];
                }

                if (vinculoSalvo) {
                  servidor.vinculo = vinculoSalvo;
                  servidor.vinculoId = vinculoSalvo.id;
                }
              }
            }
            this.emitirServidorSelecionado(servidor);
          },
          error: () => {
            this.isProgress = false;
            this.cpfForm.enable();
            this.cpfForm.reset();
            this.inputElement.nativeElement.focus();
            this.snackBar.showSnackBarError('Erro ao buscar servidor. Tente novamente.');
          }
        });
      }
    });
  }

  /**
   * Extrai telefone celular dos dados brutos do RHNet
   */
  private getTelefone(telefones: any[]): string | null {
    if (!telefones || telefones.length === 0) {
      return null;
    }

    for (const tel of telefones) {
      if (tel.tipoTelefoneDesc === 'celular') {
        return tel.ddd + tel.numero;
      }
    }

    // Se não encontrou celular, retorna o primeiro disponível
    return telefones[0] ? telefones[0].ddd + telefones[0].numero : null;
  }
}

@Component({
  templateUrl: './vinculos-servidor.html',
  styles: ['.header{ height: 40px; margin: -22px;}']
})
export class selectVinculoComponent {
  displayedColumns = ['vinculo', 'ativo', 'grupo', 'cargo', 'funcao', 'orgaoOrigem', 'orgaoLotacao'];
  selectVinculoForm: UntypedFormControl;
  tableData: any;
  columns: Column[] = [
    { def: 'vinculo', header: 'Regime Jurídico' },
    { def: 'ativo', header: 'Ativo' },
    { def: 'grupo', header: 'Grupo' },
    { def: 'cargo', header: 'Cargo' },
    { def: 'funcao', header: 'Função' },
    { def: 'orgaoOrigem', header: 'Órgão origem' },
    { def: 'orgaoLotacao', header: 'Órgão lotação' }
  ];
  pageSizeOptions = [2, 5, 10];
  selectedVinculo: any = null;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectVinculoForm = new UntypedFormControl(null);

    if (!this.data.titulo) {
      this.data.titulo = 'Selecione um vínculo';
    }

    if (!this.data.instrucoes) {
      this.data.instrucoes = 'Selecione um dos vínculos do servidor:';
    }
  }

  ngOnInit(): void {
    this.tableData = this.data.vinculos.map(vinculo => {
      return {
        id: vinculo.id,
        vinculo: vinculo.regimeJuridico.descricao,
        ativo: vinculo.ativo ? 'Sim' : 'Não',
        grupo: vinculo.cargo.grupo.descricao,
        cargo: vinculo.cargo.descricao,
        funcao: vinculo.funcaoAtividade == null ? '' : vinculo.funcaoAtividade.descricao,
        orgaoOrigem: vinculo.orgao.origem.nome,
        orgaoLotacao: vinculo.orgao.lotacao.nome,
        vinculoPtr: vinculo
      }
    });

    this.tableData.sort((a, b) => {
      if (a.ativo === 'Sim' && b.ativo !== 'Sim') return -1;
      if (a.ativo !== 'Sim' && b.ativo === 'Sim') return 1;
      return 0;
    });
  }

  vinculoSelected(vinculo?) {
    this.selectedVinculo = vinculo.vinculoPtr;
    this.dialogRef.close(vinculo.vinculoPtr);
  }

  selectVinculo(vinculo) {
    this.selectedVinculo = vinculo.vinculoPtr;
  }

  confirmSelection() {
    if (this.selectedVinculo) {
      this.dialogRef.close(this.selectedVinculo);
    }
  }
}
